import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { computed, onMounted, PropType, ref, onUpdated } from 'vue';

import { SdsSection2, SdsSection2Hazard } from '@/interfaces/model/general/sds';
import {
  getSection2GHSCategoryList,
  getSection2GHSItemList,
  getSection2HazardList,
} from '@/lib/formItem';
import { required, requiredAllowZero, requiredSelection } from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import { useMSdsSection2 } from '@/composables/useMSdsSection2';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection2Form',
  props: {
  isAdd: {
    type: Boolean,
    default: false,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object as PropType<SdsSection2>,
    required: true,
  },
},
  emits: ["update:isValid", "update:item"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:item', data: SdsSection2): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const m = defineMessages({
  physicalChemicalHazards: '物理化学的危険性 / Physical and Chemical Hazards',
  toxicityInformation: '毒性情報',
});




const updateIsValid = (e: boolean) => emits('update:isValid', e);
const updateItem = (item: SdsSection2) => emits('update:item', item);

const form = ref<VForm | null>(null);

const categoryList = computed(() => {
  return getSection2GHSCategoryList(
    getSection2CategoriesByItemId(props.item.item_id)
  );
});

const hazardList = computed(() => {
  return getSection2HazardList(mSdsSection2Hazards.value).filter((x) => {
    return x.itemId == props.item.item_id;
  });
});

const hasHazard = (itemId: number): boolean => {
  return reserved_ids.ITEM_HAS_HAZARDS.includes(itemId);
};

const updateHazard = (e: Array<number>) => {
  const data: Array<SdsSection2Hazard> = [];

  e.forEach((hazardId: number): void => {
    data.push({
      id: 0,
      sds_id: '',
      sds_section2_id: 0,
      hazard_id: hazardId,
      created_at: now().toISO(),
      updated_at: now().toISO(),
      deleted_at: null,
    });
  });
  updateItem({
    ...props.item,
    sds_section2_hazard_list: data,
  });
};

const {
  hazards: mSdsSection2Hazards,
  items: mSdsSection2Items,
  load: loadMSection2,
  reserved_ids,
  getSection2CategoriesByItemId,
} = useMSdsSection2();

onMounted((): void => {
  loadMSection2();
  if (form.value) {
    form.value.validate();
  }
});

onUpdated((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,m, props, emits, updateIsValid, updateItem, form, categoryList, hazardList, hasHazard, updateHazard, mSdsSection2Hazards, mSdsSection2Items, loadMSection2, reserved_ids, getSection2CategoriesByItemId, sharedMessages, getSection2GHSItemList, required, requiredAllowZero, requiredSelection, VForm }
}

})